'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = info;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var CORVID = {
  APP_DEF_ID: '675bbcef-18d8-41f5-800e-131ec9e08762',
  APP_DEF_NAME: 'Wix Corvid'
};

function info(window, _, _ref) {
  var _this = this;

  var dc = _ref.dc,
      renderType = _ref.renderType,
      caching = _ref.caching,
      microPop = _ref.microPop,
      wixBoltExclusionReason = _ref.wixBoltExclusionReason;
  var document = window.document,
      navigator = window.navigator,
      performance = window.performance,
      Promise = window.Promise,
      getComputedStyle = window.getComputedStyle,
      santaBase = window.santaBase,
      boltBase = window.boltBase,
      clientSideRender = window.clientSideRender,
      timeSpentInSSR = window.timeSpentInSSR,
      santaRenderingError = window.santaRenderingError,
      rendererModel = window.rendererModel,
      _window$ssrInfo = window.ssrInfo,
      ssrInfo = _window$ssrInfo === undefined ? {} : _window$ssrInfo;

  var total = function total(field) {
    return function (records) {
      return _.reduce(records, function (result, record) {
        return result + record[field];
      }, 0);
    };
  };
  var totalTransfer = total('transferSize');
  var totalSize = total('decodedBodySize');

  var round = function round(record) {
    return _.reduce(record, function (result, value, key) {
      result[key] = _.isNumber(value) ? Math.round(value) : value;
      return result;
    }, {});
  };

  var kb = function kb(bytes) {
    return bytes >> 10;
  };
  var mb = function mb(bytes) {
    return Math.round(bytes / 1024 / 1024);
  };

  var fixedNames = {
    2: 'First reLayout',
    3: 'Viewer Interactive',
    33: 'Page Interactive*',
    101: 'Page Navigation Start',
    103: 'Page Navigation Complete'
  };

  function fixStageName(entry) {
    var name = entry.name;

    var m = name.match(/\(beat (\d+)\)/);
    if (m) {
      var fixedName = fixedNames[m[1]];
      if (fixedName) {
        return _.assign({}, entry, { name: fixedName + ' ' + m[0] });
      }
    }
    return entry;
  }

  var getEntries = function getEntries(resourceType) {
    return function (filter) {
      return _(resourceType ? performance.getEntriesByType(resourceType) : performance.getEntries()).invokeMap('toJSON').filter(filter).value();
    };
  };
  var getResources = getEntries('resource');
  var getNavigation = function getNavigation() {
    return getEntries('navigation')(_.identity)[0];
  };
  var getStages = function getStages() {
    return _.map(getEntries()(function (_ref2) {
      var entryType = _ref2.entryType;
      return ['mark', 'paint'].includes(entryType);
    }), fixStageName);
  };

  function findImgElem(_ref3) {
    var initiatorType = _ref3.initiatorType,
        name = _ref3.name;

    switch (initiatorType) {
      case 'img':
        return document.querySelector('img[src="' + name + '"]');
      case 'css':
        return _.find(document.querySelectorAll('.pro-gallery canvas.gallery-item-visible'), function (el) {
          return getComputedStyle(el).getPropertyValue('background-image') === 'url("' + name + '")';
        });
    }
  }

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var lcps, system, scripts, fonts, imgs, resources, xhrs, navigation, HTMLserver, clientSpecMap, metaSiteId, platformOnPage, platformAppsOnPage, userCode, platform, hasCodeApp, clientSpecs, apps, stages, interactive, lastVisibleImg, lcp, isBolt, version, tssr, session;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (console.table) {
              _context.next = 3;
              break;
            }

            console.log('Old browser: no info to show');
            return _context.abrupt('return');

          case 3:
            _context.next = 5;
            return new Promise(function (resolve) {
              var PerformanceObserver = window.PerformanceObserver,
                  LargestContentfulPaint = window.LargestContentfulPaint;

              if (PerformanceObserver && LargestContentfulPaint) {
                new PerformanceObserver(function (entryList, observer) {
                  observer.disconnect();
                  resolve(entryList.getEntries());
                }).observe({ type: 'largest-contentful-paint', buffered: true });
              } else {
                resolve();
              }
            });

          case 5:
            lcps = _context.sent;


            console.log('%cSystem info', 'color:blue; font-weight:bold');
            system = [['User agent', navigator.userAgent]];

            if (navigator.connection && navigator.connection.effectiveType) {
              system.push(['Network type', navigator.connection.effectiveType]);
            }
            if (performance.memory && performance.memory.jsHeapSizeLimit) {
              system.push(['Heap size (MB)', mb(performance.memory.jsHeapSizeLimit)]);
            }
            console.table(system);

            console.log('%cResources info', 'color:blue; font-weight:bold');
            scripts = getResources(function (_ref5) {
              var initiatorType = _ref5.initiatorType,
                  name = _ref5.name;
              return initiatorType === 'script' || /\.js$/.test(name);
            });
            fonts = getResources(function (_ref6) {
              var initiatorType = _ref6.initiatorType,
                  name = _ref6.name;
              return initiatorType === 'css' && /font/i.test(name);
            });
            imgs = getResources(function (_ref7) {
              var initiatorType = _ref7.initiatorType,
                  name = _ref7.name;
              return (initiatorType === 'css' || initiatorType === 'img') && /\.(?:jpe?g|png|webp|gif)/i.test(name);
            });
            resources = [['Script file count', scripts.length], ['Script file size (KB)', kb(totalTransfer(scripts))], ['Script protocol', scripts[0].nextHopProtocol], ['Fonts file count', fonts.length], ['Fonts file size (KB)', kb(totalTransfer(fonts))], ['Image file count', imgs.length], ['Image file size (KB)', kb(totalTransfer(imgs))], ['iframe count', document.querySelectorAll('iframe').length], ['Comps count', document.querySelectorAll('#SITE_ROOT *[id^=comp-]').length]];

            if (clientSideRender) {
              xhrs = getResources(function (_ref8) {
                var name = _ref8.name;
                return name.includes('fixedData');
              });

              resources.push(['Page JSONs size (KB)', kb(totalSize(xhrs))]);
            }
            console.table(resources);

            navigation = getNavigation();

            if (navigation) {
              console.log('%cResponse info', 'color:blue; font-weight:bold');
              HTMLserver = [['Load type', navigation.type], ['Using DC', dc]];

              if (microPop) {
                HTMLserver.push(['Using micro-POP', microPop]);
              }
              HTMLserver.push(['Size over the wire (KB)', kb(navigation.transferSize)], ['Size on client (KB)', kb(navigation.decodedBodySize)], ['DNS time', navigation.domainLookupEnd - navigation.domainLookupStart]);
              if (navigation.secureConnectionStart) {
                HTMLserver.push(['TCP handshake', navigation.secureConnectionStart - navigation.connectStart], ['SSL handshake', navigation.connectEnd - navigation.secureConnectionStart]);
              } else {
                HTMLserver.push(['TCP handshake', navigation.connectEnd - navigation.connectStart]);
              }
              HTMLserver.push(['Request / response', navigation.responseStart - navigation.requestStart]);
              console.table(_.map(HTMLserver, round));
            }

            clientSpecMap = rendererModel.clientSpecMap, metaSiteId = rendererModel.metaSiteId;
            platformOnPage = ssrInfo.platformOnPage, platformAppsOnPage = ssrInfo.platformAppsOnPage, userCode = ssrInfo.userCode;

            if (platformOnPage) {
              console.log('%cPlatform info', 'color:blue; font-weight:bold');
              platform = [['Using platform', platformOnPage]];
              hasCodeApp = false;
              clientSpecs = Object.values(clientSpecMap);
              apps = platformAppsOnPage.map(function (appDefId) {
                if (appDefId === CORVID.APP_DEF_ID) {
                  hasCodeApp = true;
                  return CORVID.APP_DEF_NAME;
                }
                var app = clientSpecs.find(function (_ref9) {
                  var appDefinitionId = _ref9.appDefinitionId;
                  return appDefinitionId === appDefId;
                });
                return app && app.appDefinitionName || appDefId;
              });

              platform.push(['Apps', apps.join()], ['Using Corvid', userCode || hasCodeApp]);
              console.table(platform);
            }

            console.log('%cTiming info', 'color:blue; font-weight:bold');
            stages = getStages();


            if (navigation) {
              stages.push({
                name: 'Page Started / TTFB',
                startTime: navigation.responseStart
              }, {
                name: 'Page Arrived / HTML Loaded',
                startTime: navigation.responseEnd
              });
            }

            interactive = _.find(stages, function (_ref10) {
              var name = _ref10.name;
              return name.includes('(beat 33)');
            }) || _.find(stages, function (_ref11) {
              var name = _ref11.name;
              return name.includes('(beat 3)');
            });

            if (interactive) {
              lastVisibleImg = _(imgs).filter(function (_ref12) {
                var startTime = _ref12.startTime;
                return startTime < interactive.startTime;
              }).sortBy(function (_ref13) {
                var startTime = _ref13.startTime,
                    duration = _ref13.duration;
                return -(startTime + (duration || 1000000));
              }).find(function (img) {
                var el = findImgElem(img);
                if (!el || el.hidden) {
                  return false;
                }
                var rect = el.getBoundingClientRect();
                return rect.width > 0 && rect.height > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight) && getComputedStyle(el).opacity !== '0';
              });

              if (lastVisibleImg) {
                stages.push({
                  name: 'Visible Images Received*',
                  startTime: lastVisibleImg.startTime + lastVisibleImg.duration
                });
              }
              lcp = _(lcps).filter(function (_ref14) {
                var url = _ref14.url,
                    startTime = _ref14.startTime;

                if (url) {
                  startTime = performance.getEntriesByName(url)[0].startTime;
                }
                return startTime < interactive.startTime;
              }).maxBy('startTime');

              if (lcp) {
                stages.push({
                  name: 'largest-contentful-paint',
                  startTime: lcp.startTime
                });
              }
            }

            console.table(_(stages).sortBy('startTime').map(round).value(), ['name', 'startTime']);

            console.log('%cSession info', 'color:blue; font-weight:bold');
            isBolt = renderType === 'bolt';
            version = isBolt ? boltBase : santaBase;
            tssr = ssrInfo.timeSpentInSSR || timeSpentInSSR;
            session = [['Metasite ID', metaSiteId], ['Version', renderType + ' (' + version.match(/\/([^/]+)$/)[1] + ')'], ['Using SSR', !clientSideRender]];

            if (clientSideRender) {
              if (santaRenderingError) {
                session.push(['No SSR reason', santaRenderingError.errorInfo]);
              }
            } else if (caching !== 'none') {
              session.push(['SSR caching', caching + ' (' + (tssr || 'unknown') + ')']);
            } else if (tssr) {
              session.push(['SSR time', tssr]);
            }
            if (!isBolt && wixBoltExclusionReason) {
              session.push(['Bolt exclusion reason', wixBoltExclusionReason]);
            }
            console.table(session);

          case 37:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));
}
//# sourceMappingURL=info.js.map